import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserActivityService } from '@shared/helpers/user-activity.service';

export const UserActivityResolver: ResolveFn<void> = (): void => {
  return inject(UserActivityService).listenIfRequired();
};
